import type { HostPool } from "@warrenio/api-spec/spec.oats.gen";

export const hostPool1AutoId = "3590345e-0507-49d7-8e69-7fb16311a3a5";
export const hostPool1FakeId = "00000000-0000-0000-0000-000167bb0a39";
export const hostPool1PerformanceId = "d2fc6881-9316-46d7-b515-b6cddaeee927";

export const hostPool2EconomyId = "00000000-0000-0000-0000-00020e92ea50";

export const hostPools1: HostPool[] = [
    {
        created_at: "2023-09-01 15:11:21",
        description: "Standard storage",
        is_visible: true,
        is_default_designated: false,
        name: "Default",
        storage_pool_uuid: "58936ca0-a1b5-4e5d-9816-609feceaacbc",
        ui_position: 0,
        updated_at: "2024-01-25 14:39:58",
        uuid: hostPool1AutoId,
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
    {
        created_at: "2022-12-28 13:50:52",
        description: "Performance storage",
        is_visible: true,
        is_default_designated: true,
        name: "Faster",
        storage_pool_uuid: "f990fcb2-d6d8-432c-b676-94166ec789ef",
        ui_position: 2,
        updated_at: "2024-02-14 14:44:20",
        uuid: hostPool1PerformanceId,
        guest_limits: {
            cpu: { max: 16, min: 1 },
            disk_gb: { max: 750, min: 10 },
            ram_mb: { max: 49152, min: 1024 },
        },
    },

    {
        created_at: "2020-09-30 11:05:56",
        description: "Extreme storage",
        is_visible: true,
        is_default_designated: false,
        name: "Extreme",
        storage_pool_uuid: "58936ca0-a1b5-4e5d-9816-609feceaacbc",
        ui_position: 1,
        updated_at: "2023-12-15 14:46:11",
        uuid: hostPool1FakeId,
        guest_limits: {
            cpu: { max: 24, min: 2 },
            disk_gb: { max: 1024, min: 10 },
            ram_mb: { max: 65536, min: 1024 },
        },
    },
];

export const hostPools2: HostPool[] = [
    {
        created_at: "2023-10-23 09:45:42",
        description: "High speed block storage",
        is_visible: true,
        is_default_designated: false,
        name: "Performance",
        storage_pool_uuid: "6d48075c-4ef3-4ba3-993b-c1c09812a4b6",
        ui_position: 0,
        updated_at: "2023-11-27 12:24:53",
        uuid: "ae2bd247-9dba-4176-9b25-2693efa1014a",
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
    {
        created_at: "2020-09-30 11:05:56",
        description: "Economy compute and storage",
        is_visible: true,
        is_default_designated: true,
        name: "Standard",
        storage_pool_uuid: "056217b8-bf52-42ef-a85a-d1a0f25b7093",
        ui_position: 2,
        updated_at: "2023-11-27 12:24:53",
        uuid: hostPool2EconomyId,
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
];

export const hostPoolsInvisible: HostPool[] = [
    {
        created_at: "2024-05-01 10:00:00",
        description: "Invisible Pool",
        is_visible: false,
        is_default_designated: true,
        name: "Invisible",
        storage_pool_uuid: "00000000-0000-0000-0000-000000000000",
        ui_position: -1,
        updated_at: "2024-05-01 10:00:00",
        uuid: "11111111-1111-1111-1111-111111111111",
        guest_limits: {
            cpu: { max: 8, min: 1 },
            disk_gb: { max: 500, min: 10 },
            ram_mb: { max: 32768, min: 512 },
        },
    },
];
